<template>
  <div class="row">
    <div class="col-12">
      <div class="d-flex justify-content-end">
        <span v-if="isSaving">
          <b-button
            variant="primary"
            size="lg"
            disabled
          >
            <b-spinner small />
            {{ 'saving' | i18n }}
          </b-button>
        </span>
        <span v-else>
          <b-button variant="primary" size="lg" @click="saveDay" v-if="showSave">
            {{ 'save' | i18n }}
          </b-button>
        </span>
      </div>
      <div class="row poppins">
        <div class="col-12">
          <div>
            <div>
              <div class="row">
                <div class=" col-lg-7 col-sm-12 col-xs-12">
                  <BlockHeader :name="`${operationalArea ? this.$translate(operationalArea.name) : ''}`" />
                </div>
                <div class=" col-lg-5 col-sm-12 col-xs-12 top-actions">
                  <b-button variant="primary" size="sm" @click="selectShiftLog()">
                    {{ 'Shift Log' | i18n }}
                  </b-button>
                  <b-button variant="primary" size="sm" style="margin-left:15px" @click="goToTeamPlan()">
                    {{ 'Monthly plan' | i18n }}
                  </b-button>
                </div>
              </div>

              <div class="row">
                <div class=" col-lg-4 col-sm-12 col-xs-12">
                  <Input v-model="dateFormated" placeholder="Date" :viewMode="true" />
                </div>
                <div class=" col-lg-4 col-sm-12 col-xs-12">
                  <Input v-model="team.name" placeholder="Team" :viewMode="true" />
                </div>
                <div class=" col-lg-4 col-sm-12 col-xs-12">
                  <Input v-model="shiftFormated" placeholder="Shift" :viewMode="true" />
                </div>
                <div class=" col-lg-4 col-sm-12 col-xs-12">
                  <Input v-model="team.shiftLeader1.name" placeholder="Shift Leader 1" :viewMode="true" />
                </div>
                <div class=" col-lg-4 col-sm-12 col-xs-12">
                  <Input v-model="team.shiftLeader2.name" placeholder="Shift Leader 2" :viewMode="true" />
                </div>
                <div class=" col-lg-4 col-sm-12 col-xs-12">
                  <Input v-model="team.shiftLeader3.name" placeholder="Shift Leader 3" :viewMode="true" />
                </div>
              </div>
              <div class="row">
                <div class=" col-lg-4 col-sm-12 col-xs-12">
                  <AddUser :onSave="addNewUser" :selectedUsers="users" />
                  <b-button variant="outline-primary" size="sm" v-b-modal.addShiftUser v-if="showSave">
                    {{ 'Add Employee' | i18n }}
                  </b-button>
                </div>
              </div>
              <div class="row poppins">
                <div class="col-12">
                  <div class="table-wrapper">
                    <Table
                      :clickHighlight="false"
                      :columns="columns"
                      :rows="users"
                      :filter="{}"
                      :loading-instance="loadingInstance"
                      :set-loading-instance="setLoadingInstance"
                      :pagination="false"
                      tableName="avgShiftDayTable"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

import { NotificationMixin, DeleteRowMixin, AuthMixin } from '../../../../mixins';
import Notification from '../../common/notification';
import Loader from '../../common/loader';
import Table from '../../common/table';
import PageHeader from '../../common/page-header';
import BlockHeader from '../../common/block-header';
import Input from '../../common/input';
import AddUser from './add-user';
import { SHIFTS, ABSENCE_TYPES, ABSENCE_IS_NOT_PRESENT } from '../../../../../../../constants';
import api from '../../../api';

export default {
  title: 'Shift day',
  components: { Loader, PageHeader, AddUser, BlockHeader, Input, Table },
  mixins: [NotificationMixin, DeleteRowMixin, AuthMixin],
  data() {
    return {
      isSaving: false,
      loadingInstance: null,
      date: null,
      dateFormated: null,
      shift: null,
      shiftFormated: null,
      team: {
        shiftLeader1: {},
        shiftLeader2: {},
        shiftLeader3: {}
      },
      operationalArea: null,
      shiftOptions: Object.values(SHIFTS).map(i => ({ value: i, text: this.$translate(i) })),
      moment,
      shiftPositions: [],
      shiftPositionsObj: {},
      shiftPositionsUser: {},
      users: [],
      columns: [
        {
          field: 'user',
          title: this.$translate('Employee'),
          key: '1',
          align: 'left',
          renderBodyCell: ({ row }) => {
            return (
              <div>
                {row.name} ({row.email})
              </div>
            );
          }
        },
        {
          field: 'shiftPosition',
          title: this.$translate('Shift Position'),
          key: '2',
          align: 'left',
          width: 300,
          renderBodyCell: ({ row, column }) => {
            if (this.isNotPresent(row)) {
              return `${this.$translate('Absence')}: ${this.$translate(row.shiftDetails.absence)}`;
            }
            return (
              <div class="wrapper">
                <label class="input-label input-label-focus">{this.$translate('Shift Position')}</label>
                <select
                  value={this.shiftPositionsUser[row.id]}
                  onChange={e => {
                    this.shiftPositionsUser[row.id] = e.target.value;
                  }}
                  class="select-box input"
                  disabled={!this.showSave}
                >
                  <option value="" disabled selected>
                    {this.$translate('Select Shift Position')}
                  </option>
                  {this.shiftPositions.map(i => (
                    <option value={i.value}>{i.text}</option>
                  ))}
                </select>
              </div>
            );
          }
        }
      ]
    };
  },
  async created() {
    const q = this.$route.query;
    const m = moment(q.date);

    const operationalArea = await api.operationalArea.getById(q.operationalAreaId);

    const shiftDay = await api.shiftDay.get({
      year: m.format('YYYY'),
      month: m.format('MM'),
      day: m.format('DD'),
      teamId: q.teamID,
      operationalArea: operationalArea.id
    });

    const positions = await api.shiftPositions.get({ operationalArea: operationalArea.id });
    this.shiftPositions = positions.map(i => {
      this.shiftPositionsObj[i.id] = i;
      return { value: i.id, text: i.name };
    });
    const shitTemplate = (await api.shiftTemplate.get({ operationalArea: operationalArea.id }))[0];
    this.operationalArea = operationalArea;
    this.shift = q.shift;
    this.shiftFormated = this.$translate(q.shift);
    let team;
    if (shiftDay && shiftDay.id) {
      team = shiftDay.team;
    } else {
      team = shitTemplate.teams.find(i => i.id === q.teamID);
    }
    if (!team.shiftLeader1) {
      team.shiftLeader1 = {};
    }
    if (!team.shiftLeader2) {
      team.shiftLeader2 = {};
    }
    if (!team.shiftLeader3) {
      team.shiftLeader3 = {};
    }
    this.team = team;
    const users = this.team.users ? this.team.users : [];

    this.users = [
      ...users.filter(u => {
        if (u.startWorkingDate) {
          return m.isSameOrAfter(moment(u.startWorkingDate).format('YYYY-MM-DD'));
        } else {
          return true;
        }
      })
    ];

    this.users.forEach(u => {
      if (u.shiftPosition && u.shiftPosition.id) {
        this.shiftPositionsUser[u.id] = u.shiftPosition.id;
      }
    });
    this.date = q.date;
    this.dateFormated = moment(q.date).format('DD.MM.YYYY');

    if (this.showSave) {
      this.columns.push({
        field: 'actions',
        title: '',
        key: '6',
        width: 50,
        renderBodyCell: ({ row }) => {
          return (
            <div class="action-block">
              <div class="delete-button" on-click={() => this.deleteUser(row)}>
                {this.$translate('Delete')}
              </div>
            </div>
          );
        }
      });
    }
  },
  computed: {
    showSave: function() {
      if (this.isUser) {
        return false;
      }

      if (this.isCommonAdmin) {
        return true;
      }

      // const now = moment.utc().set({ h: 0, m: 0, s: 0 });
      // const dayDate = moment.utc(this.date).set({ h: 23, m: 59, s: 59 });

      // if (!dayDate.isAfter(now)) {
      //   return false;
      // }

      const team = this.team;
      const leaders = [];
      if (team.shiftLeader1) {
        leaders.push(team.shiftLeader1.id);
      }
      if (team.shiftLeader2) {
        leaders.push(team.shiftLeader2.id);
      }
      if (team.shiftLeader3) {
        leaders.push(team.shiftLeader3.id);
      }

      if (leaders.includes(this.auth.id)) {
        return true;
      }

      return false;
    }
  },
  methods: {
    isNotPresent(row) {
      if (row && row.shiftDetails && row.shiftDetails.absence) {
        const a = row.shiftDetails.absence;
        if (ABSENCE_IS_NOT_PRESENT.includes(a)) {
          return true;
        }
      }
      return false;
    },
    goToTeamPlan() {
      this.$router.push({
        name: 'Team shift plan',
        params: { teamId: this.team.id },
        query: { operationalAreaId: this.operationalArea.id, date: this.date }
      });
    },
    selectShiftLog() {
      const data = {
        operationalAreaId: this.operationalArea.id,
        date: this.date,
        team: this.team.id
      };
      this.$router.push({ name: 'Add Shift Log', query: data });
    },
    setLoadingInstance(loadingInstance) {
      this.loadingInstance = loadingInstance;
    },
    async saveDay() {
      try {
        this.isSaving = true;
        const data = {
          date: this.date,
          operationalArea: this.operationalArea,
          teamId: this.team.id,
          users: this.users.map(u => {
            const pId = this.shiftPositionsUser[u.id];
            return {
              ...u,
              shiftPosition: pId ? this.shiftPositionsObj[pId] : null
            };
          })
        };
        console.log(data, 'data');
        await api.shiftDay.save(data);
        Notification({ type: 'success', title: this.$translate('success'), message: this.$translate('success') });
        this.$router.go(-1);
      } catch (err) {
        Notification({ type: 'error', message: err.message });
      } finally {
        this.isSaving = false;
      }
    },
    addNewUser(user) {
      this.users.push({
        name: user.username,
        email: user.email,
        id: user.id
      });
    },
    async deleteUser(user) {
      await this.deleteSelectedRows(null, () => {
        this.users = this.users.filter(u => u.id !== user.id);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.main-content {
  min-height: calc(100vh - 120px);
  overflow-x: hidden;
}

.header-box {
  width: 100%;
  border: 1px solid black;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  height: 40px;
  align-items: center;
}
.box-border {
  border: 1px solid black;
  text-align: center;
  margin: 0 10px 10px 0;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.box-wrapepr {
  display: flex;
}

.select-box {
  outline: none;
  border: none;
  cursor: pointer;
  width: 100%;

  color: #495057;
  background-color: #fff;
  height: 32px !important;
  box-shadow: none !important;
  outline: 0;
  border-color: #80bdff;

  border-radius: 0.2rem !important;
  border: 1px solid #ced4da;

  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.875rem;
  display: inline-block;
  width: 100%;

  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  background: #fff
    url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e")
    no-repeat right 0.75rem center/8px 10px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.select-wrapper {
  padding: 0 10px;
}

.action-box-size {
  height: 40px;
  margin: 0 10px 10px 0;
  button {
    width: 100%;
    height: 100%;
  }
}

.action-box {
  background: #2260ff;
  color: white;
  cursor: pointer;
  height: 40px;
  margin: 0 10px 10px 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.box-with-btn {
  padding: 0;
}

.user-box {
  position: relative;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  flex-direction: column;
}
.user-box-email {
  font-size: 9px;
  color: #c7c7c7;
}

.user-box:hover .user-box-delete {
  opacity: 1;
  cursor: pointer;
}

.user-box-delete {
  position: absolute;
  width: 100%;
  height: 100%;
  background: #db474f;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 36px;
  opacity: 0;
  cursor: pointer;
  transition: all 0.5s;
}

.top-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.table-wrapper {
  margin-top: 10px;
  overflow: hidden;
}

.input-label-focus {
  font-size: 12px !important;
  top: -8px !important;
  line-height: 15px;
}
.input-label-focus-color {
  color: #80bdff !important;
}

.input {
  height: 32px !important;
}

.input-label {
  position: absolute;
  left: 10px;
  color: #80868b;
  top: 6px;
  font-size: 14px;
  background: white;
  padding: 0 5px;
  transition: all 0.2s ease-out;
  z-index: 2;
}

.wrapper {
  display: flex;
  position: relative;
}

::v-deep  .ve-table-cell-selection {
  border-bottom: 1px solid #eee !important;
}

::v-deep  .delete-button {
  background: rgb(219, 71, 79);
  color: white;
  border-color: #db474f;
  border: 2px solid #db474f;
  border-radius: 4px;
  padding: 2px 13px;
  margin: 0px 5px;
  cursor: pointer;
}

::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}
</style>
